<template>
  <div id="teachercart" class="d-flex flex-column align-center">
    <v-dialog
      v-model="cartDialog"
      :max-width="screenWidth > 1400 ? '1000px' : '800px'"
      @click:outside="closeCartDialog()"
    >
      <v-card class="overflow-x-hidden overflow-y-auto pa-3" max-height="90vh">
        <h2
          class="display-2 font-weight-bold mb-3 text-uppercase text-center primary--text"
        >
          {{ $i18n.t("products.shoppingCart") }}
        </h2>

        <!-- Horizontal divider -->
        <v-responsive class="mx-auto mb-6" width="56" height="2">
          <v-divider></v-divider>
          <v-divider></v-divider>
        </v-responsive>

        <v-row v-if="!queriedProducts">
          <v-col cols="12" class="d-flex align-center justify-center pa-4">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-col>
        </v-row>

        <div v-else>
          <v-row v-if="products.length === 0">
            <v-col
              cols="12"
              class="d-flex flex-column align-center justify-center pa-4"
              style="gap: 12px"
            >
              {{ $i18n.t("otherText.shopCartIsEmpty") }}
              <v-btn color="primary" @click="browseStore">{{
                $i18n.t("movement.goBack")
              }}</v-btn>
            </v-col>
          </v-row>
          <v-row v-else :class="screenWidth < 600 ? 'flex-column-reverse' : ''">
            <v-col cols="12" sm="6">
              <v-card
                class="overflow-x-hidden overflow-y-auto pa-3 d-flex flex-column"
                style="gap: 12px"
                :style="
                  screenWidth < 600 ? '' : 'max-height: calc(90vh - 124px)'
                "
              >
                <v-card
                  v-for="product in products"
                  :key="product.id"
                  elevation="2"
                  min-height="fit-content"
                  height="100%"
                  width="100%"
                  class="d-flex flex-row"
                >
                  <!-- <v-img
                  :src="
                    product.unAvailable
                      ? require('@/assets/logo-v2-square.svg')
                      : product.thumbnailImages[0]
                  "
                  height="64"
                  width="64"
                  max-width="64"
                  max-height="64"
                  contain
                  style="
                    border-radius: 4px;
                    border-style: solid;
                    border-width: thin;
                    border-color: rgba(0, 0, 0, 0.12);
                  "
                  :loading="
                    !product.unAvailable &&
                    !isImageLoaded(product.id, product.thumbnailImages)
                  "
                >
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0 align-center justify-center">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img> -->

                  <div class="d-flex flex-row" style="width: 100%">
                    <!-- style="width: calc(100% - 64px)" -->
                    <div
                      class="d-flex flex-column pa-2"
                      style="gap: 4px; width: calc(100% - 40px)"
                    >
                      <v-card-title
                        style="
                          font-size: 1.25rem;
                          line-height: 1.4rem;
                          text-decoration: none !important;
                          word-break: break-word;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                          overflow: hidden;
                          display: block;
                        "
                        class="pa-0"
                        ><div
                          v-html="
                            product.unAvailable
                              ? `<del>${product.title}</del>`
                              : product.title
                          "
                        ></div
                      ></v-card-title>

                      <div v-if="product.unAvailable">
                        <span class="text-caption error--text"
                          >Product no longer available</span
                        >
                      </div>
                      <div v-else>
                        <span class="text-caption"
                          ><div
                            v-html="
                              productPrice(
                                product.price,
                                product.discountPercentage,
                              )
                            "
                          ></div
                        ></span>

                        <span
                          v-if="product.addons && product.addons.length > 0"
                          class="text-caption"
                        >
                          <div
                            v-for="(addon, index) in product.addons"
                            :key="index"
                          >
                            {{ addon.title }} ({{ addon.type }}) -
                            {{ productPrice(addon.price, 0) }}
                          </div>
                        </span>
                      </div>
                    </div>
                    <v-spacer> </v-spacer>

                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="red"
                          fab
                          class="mt-auto"
                          x-small
                          icon
                          v-bind="attrs"
                          v-on="on"
                          @click="removeProductFromCart(product)"
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </template>
                      <span>{{
                        $i18n.t("actions.remove") +
                        " " +
                        $i18n.t("otherText.from") +
                        " " +
                        $i18n.t("headings.cart")
                      }}</span>
                    </v-tooltip>
                  </div>
                </v-card>
              </v-card>

              <v-btn
                v-show="screenWidth < 600"
                color="secondary"
                class="black--text mt-3"
                @click="closeCartDialog"
                >{{ $i18n.t("actions.close") }}</v-btn
              >
            </v-col>
            <v-col cols="12" sm="6">
              <v-row no-gutters>
                {{
                  $i18n.t("headings.products") +
                  " (" +
                  $i18n.t("labels.downloadable") +
                  ")"
                }}: <v-spacer></v-spacer>

                <!-- R{{ productsPrice.toFixed(2) }} -->
                <div
                  v-if="nonPhysicalProductsPrice === productsPriceWithCoupon"
                >
                  R{{ nonPhysicalProductsPrice.toFixed(2) }}
                </div>
                <div
                  v-else
                  v-html="
                    `<del>R${nonPhysicalProductsPrice.toFixed(
                      2,
                    )}</del> R${productsPriceWithCoupon.toFixed(2)}`
                  "
                ></div>
              </v-row>
              <v-row no-gutters v-if="addonsTotal > 0">
                {{ $i18n.t("labels.addons") }}: <v-spacer></v-spacer> R
                {{ addonsTotal.toFixed(2) }}
              </v-row>
              <v-row no-gutters v-show="validCoupon">
                {{ $i18n.t("labels.coupon") }}: <v-spacer></v-spacer>
                {{ couponText(validCoupon) }}
              </v-row>
              <v-row no-gutters>
                {{
                  $i18n.t("headings.products") +
                  " (" +
                  $i18n.t("headings.shipping") +
                  ")"
                }}: <v-spacer></v-spacer> R{{
                  physicalProductsPrice.toFixed(2)
                }}
              </v-row>
              <v-row no-gutters v-show="physicalProducts?.length > 0">
                {{ $i18n.t("headings.shippingFee") }}: <v-spacer></v-spacer> R
                {{ (130).toFixed(2) }}
              </v-row>
              <v-row no-gutters>
                {{
                  $i18n.t("labels.subTotal") +
                  " (" +
                  $i18n.t("labels.vatIncluded") +
                  ")"
                }}: <v-spacer></v-spacer> R
                {{ subTotal.toFixed(2) }}
              </v-row>
              <v-row no-gutters>
                {{
                  $i18n.t("labels.total") +
                  " (" +
                  $i18n.t("labels.vatExcluded") +
                  ")"
                }}: <v-spacer></v-spacer> R
                {{ exclVAT.toFixed(2) }}
              </v-row>
              <v-row no-gutters>
                {{ $i18n.t("labels.vat") }} ( 15% ): <v-spacer></v-spacer> R
                {{ totalVat.toFixed(2) }}
              </v-row>
              <v-row no-gutters>
                {{ $i18n.t("labels.total") }}: <v-spacer></v-spacer> R
                {{ subTotal.toFixed(2) }}
              </v-row>

              <div class="d-flex flex-row align-center pt-3" style="gap: 12px">
                <v-text-field
                  v-model="couponCode"
                  :label="`${$i18n.t('labels.redeemCouponCode')}`"
                  :error-messages="couponVerifyMessages"
                  :class="
                    !couponVerifyErrors
                      ? 'primary-color-text-field-message'
                      : ''
                  "
                  @keyup.enter="verifyCoupon"
                  @input="onCouponCodeInput"
                ></v-text-field>

                <v-icon
                  v-if="validCoupon && validCoupon.couponCode === couponCode"
                  color="primary"
                  >mdi-check</v-icon
                >

                <v-btn
                  color="primary"
                  v-else
                  :disabled="
                    verifyingCoupon ||
                    !couponCode ||
                    couponCode === '' ||
                    checkingOut
                  "
                  :loading="verifyingCoupon"
                  @click="verifyCoupon"
                  >{{ $i18n.t("actions.verify") }}</v-btn
                >
              </div>

              <div
                v-if="!userSignedIn"
                class="d-flex flex-row align-center pb-3"
                style="gap: 12px"
              >
                <v-text-field
                  ref="emailField"
                  v-model="email"
                  :label="
                    isEmailConfirmationStep
                      ? `${$i18n.t('labels.email')} confirmation`
                      : $i18n.t('labels.email')
                  "
                  type="email"
                  :rules="emailRules"
                  required
                ></v-text-field>

                <v-icon v-if="guestEmailConfirmed" color="primary"
                  >mdi-check</v-icon
                >

                <v-btn
                  v-if="!isEmailConfirmationStep"
                  color="primary"
                  @click="nextEmailStep"
                  :disabled="!email || email.trim() === ''"
                  >{{ $i18n.t("actions.confirm") }}</v-btn
                >
                <v-btn
                  v-else
                  color="secondary"
                  class="black--text"
                  @click="backEmailStep"
                  >{{ $i18n.t("movement.back") }}</v-btn
                >
              </div>

              <!-- <v-btn
                class="mb-2"
                color="success"
                @click="$refs.newsletter.show()"
                block
              >
                Subscribe for discounts and promotions!
              </v-btn>

              <NewsletterSubscribeDialog
                ref="newsletter"
                :show-default-button="false"
              /> -->
              <v-checkbox
                v-model="agreedToPromotionalEmails"
                :label="$i18n.t('labels.receivePromotionalEmails')"
                class="my-0 py-0"
              ></v-checkbox>
              <v-select
                v-show="agreedToPromotionalEmails"
                :items="['Teacher', 'Parent', 'School Management']"
                v-model="userGroupForPromotionalEmails"
                label="Select a user group"
                hide-details
                dense
                class="my-0 pt-0 pb-2"
              ></v-select>
              <v-btn
                color="primary"
                :disabled="!canProceedWithCart"
                :loading="
                  checkingOut || !ordersSyncedOrSignedOut || !initiallyLoaded
                "
                @click="proceedToCheckout"
                block
                v-if="physicalProducts?.length > 0"
                >{{ $i18n.t("actions.proceed") }}</v-btn
              >
              <v-btn
                color="primary"
                :disabled="!canProceedWithCart"
                :loading="checkingOut || !ordersSyncedOrSignedOut"
                @click="checkoutFreeProducts"
                block
                v-else-if="subTotal === 0"
                >{{ $i18n.t("actions.checkoutForFree") }}</v-btn
              >
              <v-btn
                color="primary"
                :disabled="!canProceedWithCart"
                :loading="checkingOut || !ordersSyncedOrSignedOut"
                @click="openPaymentMethodDialog"
                block
                v-else
                >{{ $i18n.t("actions.checkout") }}</v-btn
              >

              <div
                v-show="subTotal === 0 && ordersSyncedOrSignedOut"
                class="pt-2"
              >
                <span class="primary--text text-body-1">
                  After checkout, we will email you all the relevant order and
                  download information.
                </span>
              </div>

              <v-alert
                v-if="anyUnAvailableProducts"
                dense
                type="warning"
                class="mb-0 mt-3"
                max-width="100%"
              >
                <v-row align="center">
                  <v-col class="grow text-subtitle-1"
                    >Some products are unavailable please remove them before
                    continuing</v-col
                  >
                </v-row>
              </v-alert>

              <v-row
                v-show="screenWidth > 599"
                no-gutters
                class="pt-3 justify-end"
              >
                <v-btn
                  :disabled="checkingOut"
                  color="secondary"
                  class="black--text"
                  @click="closeCartDialog"
                  >{{ $i18n.t("actions.close") }}</v-btn
                >
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="checkoutDialog"
      max-width="800px"
      @click:outside="closeCheckoutDialog()"
    >
      <v-card
        class="overflow-x-hidden overflow-y-auto px-1 pb-1 pt-3"
        max-height="90vh"
      >
        <v-form
          ref="form"
          v-model="validCheckoutForm"
          @submit.prevent="openPaymentMethodDialog"
        >
          <h2
            class="display-2 font-weight-bold mb-3 text-uppercase text-center primary--text"
          >
            {{ $i18n.t("headings.shippingInfo") }}
          </h2>

          <!-- Horizontal divider -->
          <v-responsive class="mx-auto mb-6" width="56" height="2">
            <v-divider></v-divider>
            <v-divider></v-divider>
          </v-responsive>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="shippingDetails.address1"
                  :label="`${$i18n.t('labels.address')} 1`"
                  :rules="formRules.address1"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="shippingDetails.address2"
                  :label="`${$i18n.t('labels.address')} 2`"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="shippingDetails.city"
                  :label="$i18n.t('labels.city')"
                  :rules="formRules.city"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="shippingDetails.province"
                  :items="provinces"
                  :label="`${$i18n.t('labels.province')}*`"
                  :rules="formRules.province"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="shippingDetails.postalCode"
                  :label="$i18n.t('labels.postalCode')"
                  :rules="formRules.postalCode"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="shippingDetails.country"
                  readonly
                  :label="$i18n.t('labels.country')"
                  :rules="formRules.country"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="shippingDetails.phoneNumber"
                  :label="
                    $i18n.t('labels.phone') + ' ' + $i18n.t('labels.number')
                  "
                  :rules="formRules.phoneNumber"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="d-flex flex-wrap" style="gap: 12px">
            <v-btn
              color="secondary"
              :disabled="checkingOut"
              class="black--text"
              @click="backToCart"
              >{{ $i18n.t("movement.back") }}</v-btn
            >
            <v-spacer></v-spacer>
            <!-- <v-btn @click="closeCheckoutDialog">Close</v-btn> -->

            <div v-show="shippingChanged">
              {{ $i18n.t("products.saveShipping") }}
              <v-btn
                color="green"
                class="ml-3 white--text"
                @click="saveNewShippingDetails"
                >{{ $i18n.t("actions.yes") }}</v-btn
              >
            </div>
            <v-btn
              color="primary"
              :disabled="
                checkingOut ||
                !validCheckoutForm ||
                offline ||
                !ordersSyncedOrSignedOut
              "
              :loading="checkingOut || !ordersSyncedOrSignedOut"
              @click="openPaymentMethodDialog"
              >{{ $i18n.t("actions.checkout") }}</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="paymentMethodDialog"
      max-width="400px"
      @click:outside="backFromPaymentMethod()"
    >
      <v-card
        class="overflow-x-hidden overflow-y-auto px-1 pb-1 pt-3"
        max-height="90vh"
      >
        <v-form
          ref="form"
          v-model="validPaymentMethodForm"
          @submit.prevent="confirmPaymentMethod"
        >
          <h2
            class="display-2 font-weight-bold mb-3 text-uppercase text-center primary--text"
          >
            {{ $i18n.t("products.paymentMethod") }}
          </h2>

          <!-- Horizontal divider -->
          <v-responsive class="mx-auto mb-6" width="56" height="2">
            <v-divider></v-divider>
            <v-divider></v-divider>
          </v-responsive>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="chosenPaymentMethod"
                  :items="paymentMethods"
                  item-text="title"
                  item-value="value"
                  :label="`${$i18n.t('products.paymentMethod')}*`"
                  :rules="formRules.paymentMethod"
                  required
                ></v-select>

                <div v-show="chosenPaymentMethod === 'EFT'">
                  <span class="primary--text text-body-1">
                    After confirming, we will email you all the relevant order
                    and payment information.
                  </span>
                </div>
              </v-col>
              <!-- <v-col cols="12" sm="6" v-show="chosenPaymentMethod === 'EFT'">
                <v-card class="pa-3">
                  <span class="mb-0 text-subtitle-1"
                    ><strong>Bank Details:</strong></span
                  >
                  <p class="mb-0">Account holder: A Dempers</p>
                  <p class="mb-0">Account number: 1216434069</p>
                  <p class="mb-0">Account type: Current account</p>
                  <p class="mb-0">Bank name: Nedbank</p>
                  <p class="mb-0">Branch code: 198765</p>
                  <p class="mb-0">Reference: {{ checkoutNewOrderID }}</p>
                  <p class="mb-0">
                    Proof of payment: info@juffrouanri.com / +27 60 529 4868
                  </p>
                  <p class="mb-0">
                    Please email a bank-generated PDF proof of payment
                    (screenshots are not accepted), so that your order can be
                    verified and released.
                  </p>
                </v-card>
              </v-col> -->
            </v-row>
          </v-card-text>
          <v-card-actions class="d-flex flex-wrap" style="gap: 12px">
            <v-btn
              color="secondary"
              :disabled="checkingOut"
              class="black--text"
              @click="backFromPaymentMethod"
              >{{ $i18n.t("movement.back") }}</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="
                checkingOut ||
                !validPaymentMethodForm ||
                offline ||
                !ordersSyncedOrSignedOut
              "
              :loading="checkingOut || !ordersSyncedOrSignedOut"
              @click="confirmPaymentMethod"
              >{{ $i18n.t("actions.confirm") }}</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="bankingDetailsDialog" max-width="400px" persistent>
      <v-card
        class="overflow-x-hidden overflow-y-auto px-1 pb-1 pt-3"
        max-height="90vh"
      >
        <v-card-text>
          <v-card class="pa-3" flat>
            <span class="mb-0 text-subtitle-1"
              ><strong>Bank Details:</strong></span
            >
            <p class="mb-0">Account holder: A Dempers</p>
            <p class="mb-0">Account number: 1216434069</p>
            <p class="mb-0">Account type: Current account</p>
            <p class="mb-0">Bank name: Nedbank</p>
            <p class="mb-0">Branch code: 198765</p>
            <p class="mb-0">Reference: {{ checkoutNewOrderID }}</p>
            <p class="mb-0">
              Proof of payment: info@juffrouanri.com / +27 60 529 4868
            </p>
            <p class="mb-0">
              Please email a bank-generated PDF proof of payment (screenshots
              are not accepted), so that your order can be verified and
              released.
            </p>
          </v-card>
        </v-card-text>
        <v-card-actions class="d-flex flex-wrap justify-end" style="gap: 12px">
          <v-btn
            color="primary"
            :disabled="checkingOut"
            :loading="checkingOut"
            @click="closeBankingDetails"
            >{{ $i18n.t("actions.close") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import router from "@/router";
import { mapState } from "vuex";
import {
  DataStore,
  //  SortDirection,
  Storage,
  API,
} from "aws-amplify";
import {
  Product,
  // ProductTag,
  TeacherProductsOrder,
  ProductCategory,
  ProductBundle,
} from "@/models";
import _ from "lodash";
import MD5 from "crypto-js/md5";
// import Helper from "@/components/global-components/Helper.vue";
import store from "@/store";
import { reconfigureDatastore } from "@/plugins/datastore/config.js";
import * as mutations from "@/graphql/mutations";
import * as queries from "@/graphql/queries";
//import NewsletterSubscribeDialog from "@/components/app-components/global/NewsletterSubscribeDialog.vue";
import { createOrderReceipt, saveOrderReceipt } from "@/core/utils/orderReceipt";

export default {
  name: "TeacherCart",
  // components: { Helper },
  //components: { NewsletterSubscribeDialog },
  data: () => ({
    initiallyLoaded: false,
    needToValidateGuestCartCoupon: false,
    // openedBrowserCart: false,
    // productSubscription: null,
    queriedProducts: false,

    changedProductsArray: false,
    checkingOut: false,
    checkoutNewOrderID: "",

    // syncedProductBundleArray: [],
    // syncedProductArray: [],
    products: [],

    // syncedProducts: false,
    // syncedProductBundles: false,

    syncedProductMap: new Map(),
    syncedBundleMap: new Map(),

    loadedProductThumbnails: [],
    // pendingTeacherProductsOrder: null,

    shippingDetails: {
      address1: "",
      address2: "",
      city: "",
      province: "",
      postalCode: "",
      country: "South Africa",
      phoneNumber: "",
    },
    defaultShippingDetails: {
      address1: "",
      address2: "",
      city: "",
      province: "",
      postalCode: "",
      country: "South Africa",
      phoneNumber: "",
    },

    chosenPaymentMethod: null,

    email: "",
    firstEmail: "",
    isEmailConfirmationStep: false,
    agreedToPromotionalEmails: false,
    userGroupForPromotionalEmails: null,

    couponCode: "",
    verifyingCoupon: false,
    couponVerifyMessages: [],
    couponVerifyErrors: false,
    validCoupon: null,

    paymentMethods: [
      { title: "EFT", value: "EFT" },
      { title: "Card Payment", value: "Payfast" },
      // { title: "PayJustNow", value: "PayJustNow" },
    ],

    provinces: [
      "Eastern Cape",
      "Free State",
      "Gauteng",
      "KwaZulu-Natal",
      "Limpopo",
      "Mpumalanga",
      "Northern Cape",
      "North West",
      "Western Cape",
    ],

    cartDialog: true,
    checkoutDialog: false,
    paymentMethodDialog: false,
    bankingDetailsDialog: false,
    pendingCheckoutRedirectPath: "",

    merchant_id: "17705781", //live
    // merchant_id: "10002308", //sandbox/dev/staging

    merchant_key: "e9jy62j7ixjos", //live
    // merchant_key: "ho6e8zvucaysh", //sandbox/dev/staging

    return_url: `${window.location.origin}/purchase-confirmation`,
    cancel_url: `${window.location.origin}/app/products`,

    notify_url:
      "https://yfoov0qf5j.execute-api.eu-west-2.amazonaws.com/production/payfast/boughtProducts", //live production
    // notify_url:
    //   "https://ztd24p80lg.execute-api.eu-west-2.amazonaws.com/staging/payfast/boughtProducts", //sandbox staging

    passphrase: "PSWwerkboek1e", //live
    // passphrase: "MissAnrisClassNetwork.763-489-77", //sandbox/dev/staging

    // PayJustNow
    pjn_initiate_url:
      "https://ztd24p80lg.execute-api.eu-west-2.amazonaws.com/staging/payjustnow/initiate",
    pjn_notify_url:
      "https://ztd24p80lg.execute-api.eu-west-2.amazonaws.com/staging/payjustnow/notify",

    formRules: {
      email: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      paymentMethod: [(v) => !!v || "a Payment Method is required"],
      address1: [(v) => !!v || "Address is required"],
      city: [(v) => !!v || "City is required"],
      province: [(v) => !!v || "Province is required"],
      postalCode: [(v) => !!v || "Postal code is required"],
      country: [(v) => !!v || "Country is required"],
      phoneNumber: [
        (v) => !!v || "Phone number is required",
        (v) =>
          /^(?:\+27|0)\s?\d{2}\s?\d{3}\s?\d{4}$/.test(v) ||
          "Invalid South African phone number",
      ],
    },
    validCheckoutForm: false,
    validPaymentMethodForm: false,
  }),

  async mounted() {
    try {
      // store.commit("changeDatastorePredicates", [
      //   {
      //     model: "Product",
      //     predicate: "Teacher",
      //   },
      //   {
      //     model: "ProductBundle",
      //     predicate: "Teacher",
      //   },
      // ]);
      // const existingProductOrBundleSubscriptions =
      //   this.datastoreSubscriptions.filter(
      //     (sub) => sub.model === "Product" || sub.model === "ProductBundle"
      //   );
      // if (
      //   (!this.startedDatastoreSync || this.datastoreReady) &&
      //   !existingProductOrBundleSubscriptions.length
      // ) {
      //   reconfigureDatastore();
      // }
      // if (!this.changingDatastoreConfig) {
      //   this.syncProducts();
      //   this.syncProductBundles();
      // }
    } catch (error) {
      console.log(error);
    }
    //  finally {
    //   if (!this.initiallyLoaded) {
    //     this.initiallyLoaded = true;
    //   }
    // }
  },

  computed: {
    ...mapState({
      offline: (state) => !state.isOnline,
      teacherProfilePayfastSubscriptionResponse: (state) =>
        state.teacherProfilePayfastSubscriptionResponse,
      syncedTeacherProfileModel: (state) => state.syncedTeacherProfileModel,

      syncedTeacherProductsOrders: (state) => state.syncedTeacherProductsOrders,
      syncedTeacherProductsOrderModels: (state) =>
        state.syncedTeacherProductsOrderModels,

      syncedPendingTeacherProductsOrder: (state) =>
        state.syncedPendingTeacherProductsOrder,

      guestCart: (state) => state.guestCart,
      creatingLocalStorageCartOrder: (state) =>
        state.creatingLocalStorageCartOrder,

      // teacherProfileID: (state) => state.teacherProfileID,
      userEmail: (state) => state.userEmail,
      changingDatastoreConfig: (state) => state.changingDatastoreConfig,
      datastoreReady: (state) => state.datastoreReady,
      startedDatastoreSync: (state) => state.startedDatastoreSync,
      userSignedIn: (state) => state.userSignedIn,
      datastoreSubscriptions: (state) => state.datastoreSubscriptions,
    }),

    guestEmailConfirmed() {
      return (
        this.userSignedIn ||
        (this.isEmailConfirmationStep && this.email === this.firstEmail)
      );
    },

    canProceedWithCart() {
      return (
        !this.checkingOut &&
        !this.anyUnAvailableProducts &&
        !this.verifyingCoupon &&
        !this.offline &&
        this.ordersSyncedOrSignedOut &&
        this.guestEmailConfirmed &&
        (this.agreedToPromotionalEmails
          ? this.userGroupForPromotionalEmails
          : true)
      );
    },

    emailRules() {
      const baseRules = this.formRules.email || [];
      if (this.isEmailConfirmationStep) {
        return [
          ...baseRules,
          (v) => v === this.firstEmail || "Emails do not match",
        ];
      }
      return baseRules;
    },

    ordersSyncedOrSignedOut() {
      return this.syncedTeacherProductsOrders || !this.userSignedIn;
    },

    authMode() {
      return this.userSignedIn ? "AMAZON_COGNITO_USER_POOLS" : "AWS_IAM";
    },

    shippingChanged() {
      if (
        !this.validCheckoutForm ||
        !this.syncedTeacherProfileModel?.productsOrderShippingDetails
      ) {
        return false;
      } else {
        const unchanged =
          JSON.stringify(
            this.syncedTeacherProfileModel.productsOrderShippingDetails,
          ) === JSON.stringify(this.shippingDetails);

        return unchanged ? false : true;
      }
    },

    m_payment_id() {
      return Date.now();
    },

    screenWidth() {
      let width = this.$vuetify.breakpoint.width;
      return width;
    },

    physicalProducts() {
      return this.products.filter((product) => product.physical === true);
    },

    physicalProductsPrice() {
      if (this.physicalProducts.length === 0) return 0;

      let price = 0;

      for (let product of this.physicalProducts) {
        price +=
          product.price && product.discountPercentage
            ? product.price - product.price * (product.discountPercentage / 100)
            : product.price;
      }

      const finalPrice = price < 0 ? 0 : price;

      return finalPrice;
    },

    nonPhysicalProductsPrice() {
      if (this.products.length === 0) return 0;

      let price = 0;

      for (let product of this.products) {
        if (product.physical) continue;

        price +=
          product.price && product.discountPercentage
            ? product.price - product.price * (product.discountPercentage / 100)
            : product.price;
      }

      const finalPrice = price < 0 ? 0 : price;

      return finalPrice;
    },

    productsPriceWithCoupon() {
      if (this.products.length === 0) return 0;

      let price = 0;

      for (let product of this.products) {
        if (product.physical) continue;

        price +=
          product.price && product.discountPercentage
            ? product.price - product.price * (product.discountPercentage / 100)
            : product.price;
      }

      const parsedCoupon =
        typeof this.validCoupon === "string"
          ? JSON.parse(this.validCoupon)
          : this.validCoupon;

      if (parsedCoupon) {
        const percentageType = parsedCoupon.discount.type === "PERCENTAGE";

        price = percentageType
          ? price - price * (parsedCoupon.discount.value / 100)
          : price - parsedCoupon.discount.value;
      }

      const finalPrice = price < 0 ? 0 : price;

      return finalPrice;
    },

    addonsTotal() {
      let total = 0;
      for (let product of this.products) {
        if (
          product.unAvailable ||
          !product.addons ||
          !Array.isArray(product.addons)
        )
          continue;
        for (let addon of product.addons) {
          total += addon.price || 0;
        }
      }
      return total;
    },

    subTotal() {
      const price =
        this.physicalProducts?.length > 0
          ? 130 +
            this.productsPriceWithCoupon +
            this.physicalProductsPrice +
            this.addonsTotal
          : this.productsPriceWithCoupon + this.addonsTotal;

      return price;
    },

    exclVAT() {
      return this.subTotal ? Number.parseFloat(this.subTotal / (1 + 0.15)) : 0;
    },

    totalVat() {
      return this.subTotal
        ? Number.parseFloat((this.subTotal / (1 + 0.15) - this.subTotal) * -1)
        : 0;
    },

    allThumbnailsLoaded() {
      return this.products.every(
        (product) =>
          product.unAvailable ||
          this.loadedProductThumbnails.includes(product.id),
      );
    },

    anyUnAvailableProducts() {
      return this.products.some((product) => product.unAvailable);
    },
  },

  watch: {
    // changingDatastoreConfig: {
    //   async handler(newVal, oldVal) {
    //     // console.log("watch changingDatastoreConfig", newVal, oldVal);

    //     if (newVal === true) {
    //       return;
    //     }

    //     if (newVal === false) {
    //       this.syncProducts();
    //       this.syncProductBundles();
    //     }
    //   },
    // },

    ordersSyncedOrSignedOut: {
      async handler(val) {
        // if (
        //   !this.changingDatastoreConfig &&
        //   !this.queriedProducts &&
        //   val?.length > 0 &&
        //   this.syncedProductArray?.length > 0 &&
        //   this.syncedProductBundleArray?.length > 0
        // ) {
        //   this.queryProductsAndBundles();
        // } else if (val?.length > 0) {
        //   const pendingTeacherProductsOrder =
        //     this.syncedPendingTeacherProductsOrder;
        //   // _.find(val, { orderStatus: "QUOTING" }) ||
        //   // _.find(val, { orderStatus: "PENDING" });

        //   if (pendingTeacherProductsOrder) {
        //     // this.pendingTeacherProductsOrder = pendingTeacherProductsOrder;
        //     // console.log(
        //     //   "pendingTeacherProductsOrder._version:",
        //     //   pendingTeacherProductsOrder._version
        //     // );
        //     this.validCoupon = pendingTeacherProductsOrder.coupon || null;
        //     this.couponCode = this.validCoupon?.couponCode || "";
        //   }
        // }
        console.log(
          "ordersSyncedOrSignedOut changed, val:",
          val,
          "creatingLocalStorageCartOrder:",
          this.creatingLocalStorageCartOrder,
        );
        if (val && !this.creatingLocalStorageCartOrder) {
          await this.queryProductsAndBundles();
        }
      },
      immediate: true,
    },

    syncedPendingTeacherProductsOrder: {
      async handler(val) {
        if (
          val &&
          this.ordersSyncedOrSignedOut &&
          !this.creatingLocalStorageCartOrder
        ) {
          await this.queryProductsAndBundles();
        }
      },
      immediate: true,
    },

    creatingLocalStorageCartOrder: {
      async handler(val) {
        if (val) {
          console.log(
            "creatingLocalStorageCartOrder is true, need to validate guest cart coupon",
          );
          this.needToValidateGuestCartCoupon = true;
        } else if (
          !val &&
          this.ordersSyncedOrSignedOut &&
          this.syncedPendingTeacherProductsOrder
        ) {
          await this.queryProductsAndBundles();
        }
      },
      immediate: true,
    },

    syncedTeacherProfileModel: {
      handler: function (val) {
        if (val?.productsOrderShippingDetails) {
          this.shippingDetails = _.cloneDeep({
            ...val.productsOrderShippingDetails,
            country: "South Africa",
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    async createJustBoughtProducts(products) {
      if (!products || products.length === 0) return;

      const createJustBoughtProductMinimal = /* GraphQL */ `
        mutation CreateJustBoughtProduct(
          $input: CreateJustBoughtProductInput!
        ) {
          createJustBoughtProduct(input: $input) {
            id
            productID
            productBundleID
            categoryId
            createdAt
            updatedAt
            _version
            _lastChangedAt
            _deleted
          }
        }
      `;

      const createPromises = products.map(async (item) => {
        const input = {
          categoryId: item.categoryId,
        };

        if (item.products) {
          // This is a ProductBundle
          input.productBundleID = item.id;
        } else {
          // This is a Product
          input.productID = item.id;
        }

        console.log("item:", item);
        console.log("Creating JustBoughtProduct with input:", input);

        try {
          await API.graphql({
            query: createJustBoughtProductMinimal,
            variables: { input },
            authMode: this.authMode,
          });
        } catch (error) {
          console.error(
            "Failed to create JustBoughtProduct for item:",
            item.id,
            error,
          );
          // Continue with other items
        }
      });

      await Promise.all(createPromises);
    },

    nextEmailStep() {
      if (this.$refs.emailField && this.$refs.emailField.validate()) {
        this.firstEmail = this.email.trim();
        this.email = "";
        this.isEmailConfirmationStep = true;
      }
    },

    backEmailStep() {
      this.email = this.firstEmail;
      this.isEmailConfirmationStep = false;
    },

    onCouponCodeInput(value) {
      // Convert to uppercase and remove non-alphanumeric characters
      this.couponCode = value
        ? value
            .trim()
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, "")
        : "";
    },

    couponText(coupon) {
      if (coupon) {
        return coupon.discount.type === "PERCENTAGE"
          ? `- ${coupon.discount.value}%`
          : `- R${coupon.discount.value.toFixed(2)}`;
      } else {
        return "";
      }
    },

    async verifyCoupon() {
      if (this.couponCode === "") {
        this.couponVerifyMessages = ["Coupon code is required"];
        this.couponVerifyErrors = true;
        return;
      }

      this.verifyingCoupon = true;
      try {
        if (this.userSignedIn) {
          await API.get("couponapi", "/item/verifyCoupon", {
            queryStringParameters: {
              teacherProfileID: this.syncedTeacherProfileModel.id,
              couponCode: this.couponCode,
            },
          })
            .then(async (response) => {
              if (response?.validCoupon) {
                this.couponVerifyMessages = [];
                this.couponVerifyErrors = false;
                this.validCoupon = response.validCoupon;
                // console.log(this.validCoupon);
              } else {
                this.couponVerifyMessages = [response.error];
                this.couponVerifyErrors = true;
                this.validCoupon = null;
              }

              this.verifyingCoupon = false;
            })
            .catch((error) => {
              console.log(error);
              this.couponVerifyMessages = [
                "An error occurred while verifying the coupon, please check your internet connection or try again later.",
              ];
              this.couponVerifyErrors = true;
              this.validCoupon = null;

              this.verifyingCoupon = false;
            });
        } else {
          await API.get("couponapi", "/item/verifyCouponWithoutTeacher", {
            queryStringParameters: {
              couponCode: this.couponCode,
            },
          })
            .then(async (response) => {
              if (response?.validCoupon) {
                this.couponVerifyMessages = []; //["Confirm validation after login"];
                this.couponVerifyErrors = false;
                this.validCoupon = response.validCoupon;
                store.commit("storeCouponToGuestCart", this.validCoupon);
                // console.log(this.validCoupon);
              } else {
                this.couponVerifyMessages = [response.error];
                this.couponVerifyErrors = true;
                this.validCoupon = null;
              }

              this.verifyingCoupon = false;
            })
            .catch((error) => {
              console.log(error);
              this.couponVerifyMessages = [
                "An error occurred while verifying the coupon, please check your internet connection or try again later.",
              ];
              this.couponVerifyErrors = true;
              this.validCoupon = null;

              this.verifyingCoupon = false;
            });
        }
      } catch (error) {
        console.log(error);
      }
    },

    async checkoutFreeProducts() {
      await this.checkout("Free");
    },

    productPrice(price, discountPercentage) {
      // console.log("price:", price, "discountPercentage:", discountPercentage);
      return price && discountPercentage
        ? `<del>R${(price || 0).toFixed(2)}</del> R` +
            ((price || 0) - (price || 0) * (discountPercentage / 100)).toFixed(
              2,
            )
        : (price || 0).toFixed(2)
        ? "R" + (price || 0).toFixed(2)
        : "R" + 0;
    },

    resetForm() {
      if (this.$refs.form) this.$refs.form.reset();
      this.shippingDetails = Object.assign({}, this.defaultShippingDetails);
      this.valid = false;
      this.validCheckoutForm = false;
      this.validPaymentMethodForm = false;

      this.isEmailConfirmationStep = false;
      this.firstEmail = "";
      this.email = "";
    },

    backFromPaymentMethod() {
      this.paymentMethodDialog = false;
      if (this.physicalProducts?.length > 0) {
        this.checkoutDialog = true;
      } else {
        this.cartDialog = true;
      }
    },

    async openPaymentMethodDialog() {
      // if (!this.userSignedIn) {
      //   this.cartDialog = false;
      //   this.checkoutDialog = false;
      //   this.paymentMethodDialog = false;
      //   store.commit("storeShippingToGuestCart", this.shippingDetails);

      //   this.$router.push({ path: `/cart` });
      //   return;
      // }

      const existingOrderID = this.syncedPendingTeacherProductsOrder?.orderID;

      const hasReusableOrderID = existingOrderID && existingOrderID > "";

      this.checkoutNewOrderID = hasReusableOrderID
        ? existingOrderID
        : this.generateOrderID();

      // Persist the newly generated orderID to the datamodel so that if this
      // function runs again for the same order it reuses this orderID instead
      // of generating a new one. Only for signed-in users who already have a
      // synced TeacherProductsOrder record (guests get their record created
      // via Lambda during checkout).
      if (
        !hasReusableOrderID &&
        this.userSignedIn &&
        this.syncedPendingTeacherProductsOrder?.id
      ) {
        const updatedTPO = await API.graphql({
          query: mutations.updateTeacherProductsOrder,
          variables: {
            input: {
              id: this.syncedPendingTeacherProductsOrder.id,
              _version: this.syncedPendingTeacherProductsOrder._version,
              orderID: this.checkoutNewOrderID,
            },
          },
          authMode: this.authMode,
        }).catch((error) => {
          console.log("error saving orderID:", error);
        });

        if (updatedTPO?.data?.updateTeacherProductsOrder) {
          store.commit("storePendingTeacherProductsOrder", {
            ...updatedTPO.data.updateTeacherProductsOrder,
            orderProducts: this.syncedPendingTeacherProductsOrder.orderProducts,
          });
        }
      }

      if (this.cartDialog) {
        this.cartDialog = false;
      } else if (this.checkoutDialog) {
        this.checkoutDialog = false;
      }

      this.paymentMethodDialog = true;
    },

    closeBankingDetails() {
      this.bankingDetailsDialog = false;

      const redirectPath = this.pendingCheckoutRedirectPath;
      this.pendingCheckoutRedirectPath = "";

      this.resetForm();
      this.$emit("openCloseCartDialog");

      if (redirectPath) {
        this.$router.push({ path: redirectPath });
      }
    },

    async confirmPaymentMethod() {
      await this.checkout(this.chosenPaymentMethod);
      this.paymentMethodDialog = false;
    },

    async saveNewShippingDetails() {
      await API.graphql({
        query: mutations.updateTeacherProfile,
        variables: {
          input: {
            id: this.syncedTeacherProfileModel.id,
            _version: this.syncedTeacherProfileModel._version,
            productsOrderShippingDetails: JSON.stringify(this.shippingDetails),
          },
        },
        authMode: this.authMode,
      });

      // await DataStore.save(
      //   TeacherProfile.copyOf(this.syncedTeacherProfileModel, (updateModel) => {
      //     updateModel.productsOrderShippingDetails = this.shippingDetails;
      //   }),
      // );

      // await API.graphql({
      //   query: mutations.updateTeacherProfile,
      //   variables: {
      //     input: {
      //       id: this.syncedTeacherProfileModel.id,
      //       _version: this.syncedTeacherProfileModel._version,
      //       productsOrderShippingDetails: JSON.stringify(this.shippingDetails),
      //     },
      //   },
      //   authMode: this.authMode,
      // }).catch((error) => {
      //   console.log("error:", error);
      // });
    },

    async checkout(paymentMethod) {
      if (!this.initiallyLoaded) return;

      this.checkingOut = true;

      let orderIDForRedirect;
      let orderPKForPayment;

      const newOrderID =
        this.checkoutNewOrderID > ""
          ? this.checkoutNewOrderID
          : this.generateOrderID();

      const receipt = await createOrderReceipt();

      if (!this.userSignedIn) {
        // Guest flow - create Cognito user + TeacherProfile + TeacherProductsOrder via Lambda

        const guestCart = {
          orderProducts: _.uniqBy(this.products, "id"),
          coupon: this.validCoupon ? this.validCoupon : null,
          orderShippingDetails:
            this.physicalProducts?.length > 0 ? this.shippingDetails : null,
          meta: this.guestCart?.meta || null,
        };

        try {
          const response = await API.post(
            "guestcartapi",
            "/item/create-guest-order",
            {
            body: {
              email: this.email,
              guestCart,
              paymentMethod,
              orderID: newOrderID,
              expectedTotal: parseFloat(this.subTotal.toFixed(2)),
              thankyouTokenHash: receipt?.hash,
            },
            },
          );

          if (!response.success) {
            this.checkingOut = false;
            return;
          }

          if (
            this.agreedToPromotionalEmails &&
            this.userGroupForPromotionalEmails
          ) {
            const mailchimpSubscribeRes = await API.post(
              "mailchimpnewsletterapi",
              "/item/subscribe",
              {
                body: {
                  email: this.email,
                  userGroup: this.userGroupForPromotionalEmails,
                },
              },
            );

            console.log("mailchimp subscribe response:", mailchimpSubscribeRes);
          }

          await this.createJustBoughtProducts(guestCart.orderProducts);

          const createdOrder = response.order;
          orderIDForRedirect = createdOrder.orderID;
          orderPKForPayment = createdOrder.id;

          if (receipt) {
            saveOrderReceipt(createdOrder.orderID, createdOrder.id, receipt.token);
          }
          
          // // Clear guest cart so it doesn't reappear
          // store.commit("storeProductsToGuestCart", []);
          // store.commit("storeCouponToGuestCart", null);
          // store.commit("storeShippingToGuestCart", null);
        } catch (error) {
          console.error(error);
          this.checkingOut = false;
          return;
        }
      } else {
        // === ORIGINAL SIGNED-IN LOGIC (unchanged except we set vars at the end) ===

        const uniqueProducts = _.uniqBy(this.products, "id");

        const teacherProductsOrderDetails = {
          id: this.syncedPendingTeacherProductsOrder.id,
          _version: this.syncedPendingTeacherProductsOrder._version,
          orderProducts:
            this.products.length > 0 ? JSON.stringify(uniqueProducts) : null,
          orderTotal: parseFloat(this.subTotal.toFixed(2)),
          orderVAT: parseFloat(this.totalVat.toFixed(2)),
          orderDateTime: new Date().toISOString(),
          orderID: newOrderID,
          updatedAtMonth: new Date().toISOString().slice(0, 7),
          coupon: this.validCoupon ? JSON.stringify(this.validCoupon) : null,
          thankyouTokenHash: receipt?.hash,
        };

        if (this.physicalProducts?.length > 0) {
          teacherProductsOrderDetails.orderShippingDetails = JSON.stringify(
            this.shippingDetails,
          );
        }
        if (typeof paymentMethod === "string") {
          teacherProductsOrderDetails.orderPaymentMethod = paymentMethod;
          if (paymentMethod === "EFT") {
            teacherProductsOrderDetails.orderStatus = "PROCESSING";
          } else if (paymentMethod === "Free") {
            teacherProductsOrderDetails.orderStatus = "PAID";
          }
        }

        const updatedTPO = await API.graphql({
          query: mutations.updateTeacherProductsOrder,
          variables: {
            input: teacherProductsOrderDetails,
          },
          authMode: this.authMode,
        }).catch((error) => {
          console.log("error:", error);
        });

        if (!updatedTPO?.data?.updateTeacherProductsOrder) {
          this.checkingOut = false;
          return;
        } else {
          store.commit("storePendingTeacherProductsOrder", {
            ...updatedTPO.data.updateTeacherProductsOrder,
            orderProducts: uniqueProducts,
          });

          if (receipt) {
            saveOrderReceipt(
              newOrderID,
              updatedTPO.data.updateTeacherProductsOrder.id,
              receipt.token,
            );
          }
        }

        await this.createJustBoughtProducts(uniqueProducts);

        let smart = this.syncedTeacherProfileModel?.smartProductSort
          ? _.cloneDeep(this.syncedTeacherProfileModel.smartProductSort)
          : { grades: [], categories: [] };
        if (!smart.grades) smart.grades = [];
        if (!smart.categories) smart.categories = [];
        for (const product of this.products) {
          if (!smart.categories.includes(product.categoryId)) {
            smart.categories.push(product.categoryId);
          }
          const category = await DataStore.query(
            ProductCategory,
            product.categoryId,
          );
          if (
            category &&
            category.grade &&
            !smart.grades.includes(category.grade)
          ) {
            smart.grades.push(category.grade);
          }
        }
        smart.grades = [...new Set(smart.grades)];
        smart.categories = [...new Set(smart.categories)];

        const profileInput = {
          id: this.syncedTeacherProfileModel.id,
          _version: this.syncedTeacherProfileModel._version,
          smartProductSort: JSON.stringify(smart),
        };

        if (
          this.physicalProducts?.length > 0 &&
          !this.syncedTeacherProfileModel?.productsOrderShippingDetails
        ) {
          profileInput.productsOrderShippingDetails = JSON.stringify(
            this.shippingDetails,
          );
        }

        await API.graphql({
          query: mutations.updateTeacherProfile,
          variables: { input: profileInput },
          authMode: this.authMode,
        });

        // // ------------------------ UPDATE TEACHER PROFILE WITH SMART SORT (and shipping details if needed) - this is used for sorting products in the shop and remembering shipping details for next time - -----------------------
        // await API.graphql({
        //   query: mutations.updateTeacherProfile,
        //   variables: {
        //     input: {
        //       id: this.syncedTeacherProfileModel.id,
        //       _version: this.syncedTeacherProfileModel._version,
        //       smartProductSort: JSON.stringify(smart),
        //     },
        //   },
        //   authMode: this.authMode,
        // });

        // // const variables = {
        // //   input: {
        // //     id: this.syncedTeacherProfileModel.id,
        // //     _version: this.syncedTeacherProfileModel._version,
        // //     smartProductSort: JSON.stringify(smart),
        // //   },
        // // };

        // if (
        //   this.physicalProducts?.length > 0 &&
        //   !this.syncedTeacherProfileModel?.productsOrderShippingDetails
        // ) {
        //   await DataStore.save(
        //     TeacherProfile.copyOf(
        //       this.syncedTeacherProfileModel,
        //       (updateModel) => {
        //         updateModel.productsOrderShippingDetails = this.shippingDetails;
        //         updateModel.smartProductSort = smart;
        //       },
        //     ),
        //   );
        // } else {
        //   await DataStore.save(
        //     TeacherProfile.copyOf(
        //       this.syncedTeacherProfileModel,
        //       (updateModel) => {
        //         updateModel.smartProductSort = smart;
        //       },
        //     ),
        //   );
        // }
        // // --------------------------------

        orderIDForRedirect = newOrderID;

        if (paymentMethod === "Payfast") {
          orderPKForPayment = this.syncedPendingTeacherProductsOrder.id;
        }
      }

      // === COMMON BLOCK (Payfast or navigate) ===
      if (paymentMethod === "Payfast") {
        const amount = parseFloat(this.subTotal.toFixed(2));
        const newReturnURL = `${this.return_url}/${orderIDForRedirect}`.trim();
        const cancelURL = this.userSignedIn
          ? this.cancel_url.trim()
          : window.location.origin;

        const data = {
          merchant_id: this.merchant_id.trim(),
          merchant_key: this.merchant_key.trim(),
          return_url: newReturnURL,
          cancel_url: cancelURL,
          notify_url: this.notify_url.trim(),
          email_address: this.userSignedIn
            ? this.userEmail.trim()
            : this.email.trim(),
          m_payment_id: this.m_payment_id,
          amount: amount,
          item_name: `Juffrou Anri - Order ${orderIDForRedirect}`,
          custom_str1: orderPKForPayment,
        };

        const keyValue =
          "merchant_id=" +
          encodeURIComponent(data.merchant_id) +
          "&merchant_key=" +
          encodeURIComponent(data.merchant_key) +
          "&return_url=" +
          encodeURIComponent(data.return_url) +
          "&cancel_url=" +
          encodeURIComponent(data.cancel_url) +
          "&notify_url=" +
          encodeURIComponent(data.notify_url) +
          "&email_address=" +
          encodeURIComponent(data.email_address) +
          "&m_payment_id=" +
          data.m_payment_id +
          "&amount=" +
          data.amount +
          "&item_name=" +
          encodeURIComponent(data.item_name) +
          "&custom_str1=" +
          encodeURIComponent(data.custom_str1) +
          "&passphrase=" +
          encodeURIComponent(this.passphrase.trim());

        const paymentSignature = MD5(keyValue.replace(/%20/g, "+"));
        data["signature"] = paymentSignature.toString();

        const form = document.createElement("form");
        form.action = "https://www.payfast.co.za/eng/process"; //live
        // form.action = "https://sandbox.payfast.co.za/eng/process"; //sandbox/dev
        form.method = "post";
        form.style.display = "none";

        for (let key in data) {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          input.value = data[key];
          form.appendChild(input);
        }

        document.body.appendChild(form);
        form.submit();
      } else if (this.userSignedIn) {
        this.checkingOut = false;

        if (paymentMethod === "EFT") {
          this.pendingCheckoutRedirectPath = `/app/productorders/${orderIDForRedirect}`;
          this.bankingDetailsDialog = true;
          return;
        }

        this.resetForm();
        this.$emit("openCloseCartDialog");
        this.$router.push({ path: `/app/productorders/${orderIDForRedirect}` });
      } else {
        this.checkingOut = false;

        if (paymentMethod === "EFT") {
          this.pendingCheckoutRedirectPath = `/purchase-confirmation/${orderIDForRedirect}`;
          this.bankingDetailsDialog = true;
          return;
        }

        this.resetForm();
        this.$emit("openCloseCartDialog");
        this.$router.push({
          path: `/purchase-confirmation/${orderIDForRedirect}`,
        });
      }
    },

    generateOrderID() {
      const now = new Date();
      const year = now.getFullYear().toString().slice(-2); // Get last 2 digits of year
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now.getDate().toString().padStart(2, "0");
      const hour = now.getHours().toString().padStart(2, "0");
      const minute = now.getMinutes().toString().padStart(2, "0");
      const second = now.getSeconds().toString().padStart(2, "0");
      const millisecond = Math.floor(now.getMilliseconds() / 10)
        .toString()
        .padStart(2, "0");
      if (this.userSignedIn) {
        return `${year}${month}${day}-${hour}${minute}${second}${millisecond}`;
      } else {
        return `${year}${month}${day}-${hour}${minute}${second}${millisecond}-G`;
      }
      // return `${year}${month}${day}-${hour}${minute}${second}${millisecond}`;
    },

    async proceedToCheckout() {
      let ableToProceed = true;
      // let datastoreSuccess = false;

      if (this.initiallyLoaded && this.changedProductsArray) {
        // await DataStore.save(
        //   TeacherProductsOrder.copyOf(
        //     this.pendingTeacherProductsOrder,
        //     (updateModel) => {
        //       // updateModel.orderStatus = "PENDING";
        //       updateModel.orderProducts =
        //         this.products.length > 0 ? [...new Set(this.products)] : null;
        //     }
        //   )
        // )
        //   .then((response) => {
        //     if (response) {
        //       datastoreSuccess = true;
        //     }
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });

        const uniqueProducts = _.uniqBy(this.products, "id");

        if (this.userSignedIn) {
          const teacherProductsOrderDetails = {
            id: this.syncedPendingTeacherProductsOrder.id,
            _version: this.syncedPendingTeacherProductsOrder._version, // add the "_version" field if your AppSync API has conflict detection (required for DataStore) enabled
            orderProducts:
              this.products.length > 0 ? JSON.stringify(uniqueProducts) : null,
            updatedAtMonth: new Date().toISOString().slice(0, 7),
          };

          const updatedTPO = await API.graphql({
            query: mutations.updateTeacherProductsOrder,
            variables: {
              input: teacherProductsOrderDetails,
            },
            authMode: this.authMode,
          }).catch((error) => {
            // console.log("error:", error);
          });

          // console.log("updatedTPO:", updatedTPO);

          if (!updatedTPO?.data?.updateTeacherProductsOrder) {
            ableToProceed = false;
          }
          {
            store.commit("storePendingTeacherProductsOrder", {
              ...updatedTPO.data.updateTeacherProductsOrder,
              orderProducts: uniqueProducts,
            });
          }
        } else {
          store.commit("storeProductsToGuestCart", uniqueProducts);
        }
      }
      //  else {
      //   datastoreSuccess = true;
      // }

      if (!ableToProceed) return;

      this.cartDialog = false;
      this.checkoutDialog = true;
    },

    backToCart() {
      this.checkoutDialog = false;
      this.cartDialog = true;
    },

    // closePaymentMethodDialog() {
    //       this.paymentMethodDialog = false;
    // },

    closeCheckoutDialog() {
      this.checkoutDialog = false;
      this.cartDialog = true;
      // this.$emit("openCloseCartDialog");
    },

    async closeCartDialog() {
      if (this.initiallyLoaded && this.changedProductsArray) {
        // await DataStore.save(
        //   TeacherProductsOrder.copyOf(
        //     this.pendingTeacherProductsOrder,
        //     (updateModel) => {
        //       // updateModel.orderStatus = "PENDING";
        //       updateModel.orderProducts =
        //         this.products.length > 0 ? [...new Set(this.products)] : null;
        //     }
        //   )
        // );

        const uniqueProducts = _.uniqBy(this.products, "id");

        if (this.userSignedIn) {
          const teacherProductsOrderDetails = {
            id: this.syncedPendingTeacherProductsOrder.id,
            _version: this.syncedPendingTeacherProductsOrder._version, // add the "_version" field if your AppSync API has conflict detection (required for DataStore) enabled
            orderProducts:
              this.products.length > 0 ? JSON.stringify(uniqueProducts) : null,
            updatedAtMonth: new Date().toISOString().slice(0, 7),
          };

          const updatedTPO = await API.graphql({
            query: mutations.updateTeacherProductsOrder,
            variables: {
              input: teacherProductsOrderDetails,
            },
            authMode: this.authMode,
          }).catch((error) => {
            // console.log("error:", error);
          });

          // console.log("updatedTPO:", updatedTPO);

          if (updatedTPO?.data?.updateTeacherProductsOrder) {
            store.commit("storePendingTeacherProductsOrder", {
              ...updatedTPO.data.updateTeacherProductsOrder,
              orderProducts: uniqueProducts,
            });
          }
        } else {
          store.commit("storeProductsToGuestCart", uniqueProducts);
        }
      }

      this.resetForm();
      this.$emit("openCloseCartDialog");
    },

    async browseStore() {
      if (this.initiallyLoaded && this.changedProductsArray) {
        // await DataStore.save(
        //   TeacherProductsOrder.copyOf(
        //     this.pendingTeacherProductsOrder,
        //     (updateModel) => {
        //       // updateModel.orderStatus = "PENDING";
        //       updateModel.orderProducts =
        //         this.products.length > 0 ? [...new Set(this.products)] : null;
        //     }
        //   )
        // );

        const uniqueProducts = _.uniqBy(this.products, "id");

        if (this.userSignedIn) {
          const teacherProductsOrderDetails = {
            id: this.syncedPendingTeacherProductsOrder.id,
            _version: this.syncedPendingTeacherProductsOrder._version, // add the "_version" field if your AppSync API has conflict detection (required for DataStore) enabled
            orderProducts:
              this.products.length > 0 ? JSON.stringify(uniqueProducts) : null,
            updatedAtMonth: new Date().toISOString().slice(0, 7),
          };

          const updatedTPO = await API.graphql({
            query: mutations.updateTeacherProductsOrder,
            variables: {
              input: teacherProductsOrderDetails,
            },
            authMode: this.authMode,
          }).catch((error) => {
            // console.log("error:", error);
          });

          // console.log("updatedTPO:", updatedTPO);

          if (updatedTPO?.data?.updateTeacherProductsOrder) {
            store.commit("storePendingTeacherProductsOrder", {
              ...updatedTPO.data.updateTeacherProductsOrder,
              orderProducts: uniqueProducts,
            });
          }
        } else {
          store.commit("storeProductsToGuestCart", uniqueProducts);
        }
      }

      this.resetForm();
      this.$emit("openCloseCartDialog");

      if (this.$router.app._route.name !== "AppProducts" && this.userSignedIn) {
        this.$router.push({ path: "/app/products" });
      }
    },

    isImageLoaded(productId, thumbnailImages) {
      if (
        !thumbnailImages ||
        !Array.isArray(thumbnailImages) ||
        thumbnailImages.length === 0
      )
        return false;

      if (this.loadedProductThumbnails.includes(productId)) return true;

      if (thumbnailImages.length === 0) return false;
      const img = new Image();
      img.onload = () => {
        this.loadedProductThumbnails.push(productId);
        return true;
      };
      img.onerror = () => {
        return false;
      };
      img.src = thumbnailImages[0];
      return false;
    },

    async removeProductFromCart(product) {
      const newProductsOrderArray = this.products.filter((p) => {
        return p.id !== product.id;
      });

      // After removing the product, work out which remaining products are still
      // recommended by something left in the cart.
      const remainingRecommendedMap = this.buildRecommendedDiscountMap(
        newProductsOrderArray,
      );

      newProductsOrderArray.forEach((p) => {
        // Only ever strip a recommended discount from a product that actually
        // received one. We never grant a discount here: doing so would wrongly
        // discount a former parent just because a remaining product happens to
        // recommend it back (the mutual-recommendation loophole).
        if (p.isRecommendedDiscount !== true) return;

        // If a product still in the cart recommends p, leave its discount as-is.
        if ((remainingRecommendedMap.get(p.id) || 0) > 0) return;

        // The recommending parent is gone: revert to the product's own sale
        // discount and clear the recommended flag. The costing computeds
        // recalculate automatically off this.products.
        const baseDiscount = this.resolveBaseSaleDiscount(p);
        this.$set(p, "discountPercentage", baseDiscount);
        this.$set(p, "effectiveDiscount", baseDiscount);
        this.$set(p, "recommendedDiscount", 0);
        this.$set(p, "isRecommendedDiscount", false);
      });

      this.products = newProductsOrderArray;

      this.changedProductsArray = true;

      // if (newProductsOrderArray?.length > 0) {
      //   await DataStore.save(
      //     TeacherProductsOrder.copyOf(
      //       this.pendingTeacherProductsOrder,
      //       (updateModel) => {
      //         updateModel.orderProducts = newProductsOrderArray;
      //       }
      //     )
      //   );
      // } else {
      //   // await DataStore.delete(this.pendingTeacherProductsOrder).then(() => {
      //   //   this.$emit("openCloseCartDialog");
      //   // });
      //   await DataStore.save(
      //     TeacherProductsOrder.copyOf(
      //       this.pendingTeacherProductsOrder,
      //       (updateModel) => {
      //         updateModel.orderProducts = null;
      //       }
      //     )
      //   );
      // }
    },

    // Mirrors recommendedDiscountMap in ProductsGrid.vue: from the given cart
    // line items (parents), builds a Map of recommendedProductId -> highest
    // recommended discountPercentage. A product only earns a recommended
    // discount while a DIFFERENT product that recommends it is in the cart.
    // Recommendations are read from the cart line, falling back to the live
    // catalog product so the map is reliable even for older cart entries.
    buildRecommendedDiscountMap(orderProducts) {
      const map = new Map();
      (orderProducts || []).forEach((op) => {
        let recs = op.recommendations;
        if (!recs) {
          const catalog =
            this.syncedProductMap.get(op.id) || this.syncedBundleMap.get(op.id);
          recs = catalog && catalog.recommendations;
        }
        if (typeof recs === "string") {
          try {
            recs = JSON.parse(recs);
          } catch (e) {
            recs = [];
          }
        }
        if (Array.isArray(recs)) {
          recs.forEach((rec) => {
            const discountPercentage =
              typeof rec.discountPercentage === "string"
                ? parseFloat(rec.discountPercentage)
                : rec.discountPercentage;

            // Ignore self-references so a product can't keep itself discounted.
            if (
              rec.productId &&
              rec.productId !== op.id &&
              discountPercentage > 0
            ) {
              const current = map.get(rec.productId) || 0;
              map.set(rec.productId, Math.max(current, discountPercentage));
            }
          });
        }
      });
      return map;
    },

    // Recovers a product's own sale discount (without the recommended portion).
    resolveBaseSaleDiscount(p) {
      // 1) The base discount recorded when the product was added to the cart.
      if (
        p.baseDiscountPercentage != null &&
        !isNaN(Number(p.baseDiscountPercentage))
      ) {
        return Number(p.baseDiscountPercentage) || 0;
      }
      // 2) The live catalog product's own sale discount.
      const catalog =
        this.syncedProductMap.get(p.id) || this.syncedBundleMap.get(p.id);
      if (catalog && catalog.discountPercentage != null) {
        return Number(catalog.discountPercentage) || 0;
      }
      // 3) Last resort: subtract the recorded recommended portion from the
      // combined discount currently on the line item.
      const current = Number(p.discountPercentage) || 0;
      const rec = Number(p.recommendedDiscount) || 0;
      return Math.max(current - rec, 0);
    },

    // async syncProducts() {
    //   try {
    //     const currentDateTime = new Date().toISOString();

    //     const productSubscription = DataStore.observeQuery(Product, (product) =>
    //       product.and((f) => [
    //         f.and((f) => [
    //           f.eCommerceProduct("eq", true),
    //           //HIDE-subscription-17Dec2024

    //           // this.syncedSubscribedCategoryIDArray.map((id) =>
    //           //   f.categoryId("ne", id)
    //           // ),
    //         ]),
    //         f.thumbnails("gt", []),
    //         f.publishDate("lt", currentDateTime),
    //       ])
    //     ).subscribe(
    //       async (snapshot) => {
    //         const { isSynced, items } = snapshot;
    //         // console.log("sync products", isSynced, items);
    //         this.syncedProductArray = items;

    //         if (
    //           !this.queriedProducts &&
    //           this.syncedTeacherProductsOrderModels?.length > 0 &&
    //           this.syncedProductBundleArray?.length > 0
    //         ) {
    //           this.queryProductsAndBundles();
    //         }

    //         if (isSynced) {
    //           this.syncedProducts = true;
    //         } else {
    //           this.syncedProducts = false;
    //         }
    //       },
    //       (error) => {
    //         console.log(error);
    //       }
    //     );

    //     store.commit("addSubscription", {
    //       model: "Product-TeacherCart",
    //       sub: productSubscription,
    //     });
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },

    // syncProductBundles() {
    //   const productBundleSubscription = DataStore.observeQuery(
    //     ProductBundle
    //   ).subscribe(
    //     async (snapshot) => {
    //       const { isSynced, items } = snapshot;

    //       this.syncedProductBundleArray = items;

    //       if (
    //         !this.queriedProducts &&
    //         this.syncedTeacherProductsOrderModels?.length > 0 &&
    //         this.syncedProductArray?.length > 0
    //       ) {
    //         this.queryProductsAndBundles();
    //       }

    //       if (isSynced) {
    //         this.syncedProductBundles = true;
    //       } else {
    //         this.syncedProductBundles = false;
    //       }
    //     },
    //     (error) => {
    //       console.log(error);
    //     }
    //   );

    //   store.commit("addSubscription", {
    //     model: "ProductBundle-TeacherCart",
    //     sub: productBundleSubscription,
    //   });
    // },

    async fetchItems(orderProducts) {
      const productIdsToFetch = new Set();
      const bundleIdsToFetch = new Set();

      orderProducts.forEach((item) => {
        const id = item.id;
        if (item.products) {
          if (!this.syncedBundleMap.has(id)) bundleIdsToFetch.add(id);
        } else {
          if (!this.syncedProductMap.has(id)) productIdsToFetch.add(id);
        }
      });

      const currentDateTime = new Date().toISOString();

      if (productIdsToFetch.size) {
        const promises = Array.from(productIdsToFetch).map((id) =>
          API.graphql({
            query: queries.getProduct,
            variables: { id },
            authMode: this.authMode,
          })
            .catch((err) => {
              console.log(err);
              return null;
            })
            .then((res) => {
              const p = res?.data?.getProduct;
              if (
                p &&
                p.eCommerceProduct === true &&
                (p.thumbnails?.length || 0) > 0 &&
                p.publishDate < currentDateTime
              ) {
                return p;
              }
              return null;
            }),
        );
        const results = await Promise.all(promises);
        results.forEach((p) => {
          if (p) this.syncedProductMap.set(p.id, p);
        });
      }

      if (bundleIdsToFetch.size) {
        const promises = Array.from(bundleIdsToFetch).map((id) =>
          API.graphql({
            query: queries.getProductBundle,
            variables: { id },
            authMode: this.authMode,
          })
            .catch((err) => {
              console.log(err);
              return null;
            })
            .then((res) => res?.data?.getProductBundle || null),
        );
        const results = await Promise.all(promises);
        results.forEach((b) => {
          if (b) this.syncedBundleMap.set(b.id, b);
        });
      }
    },

    async queryProductsAndBundles() {
      console.log("queryProductsAndBundles");
      try {
        const pendingTeacherProductsOrder =
          this.syncedPendingTeacherProductsOrder;

        if (
          pendingTeacherProductsOrder ||
          this.guestCart?.orderProducts?.length > 0
        ) {
          this.validCoupon =
            pendingTeacherProductsOrder?.coupon ||
            this.guestCart?.coupon ||
            null;
          this.couponCode = this.validCoupon?.couponCode || "";

          if (
            pendingTeacherProductsOrder &&
            this.needToValidateGuestCartCoupon
          ) {
            try {
              await this.verifyCoupon();
              this.needToValidateGuestCartCoupon = false;
            } catch (error) {
              console.log("Error verifying coupon on load:", error);
              // this.couponVerifyMessages = [
              //   "An error occurred while verifying the coupon, please check your internet connection or try again later.",
              // ];
              // this.couponVerifyErrors = true;
              //  this.validCoupon = null;
              //  this.needToValidateGuestCartCoupon = false;
            }
          }

          if (
            pendingTeacherProductsOrder?.orderProducts?.length > 0 ||
            this.guestCart?.orderProducts?.length > 0
          ) {
            const mutableProducts = _.cloneDeep(
              pendingTeacherProductsOrder?.orderProducts ||
                this.guestCart?.orderProducts,
            );

            if (this.guestCart?.orderShippingDetails) {
              this.shippingDetails = _.cloneDeep({
                ...this.guestCart.orderShippingDetails,
                country: "South Africa",
              });
            }

            await this.fetchItems(mutableProducts);

            mutableProducts.forEach((product) => {
              product.unAvailable =
                !this.syncedProductMap.has(product.id) &&
                !this.syncedBundleMap.has(product.id);
            });

            // Remove products not in mutableProducts
            this.products = this.products.filter((product) =>
              mutableProducts.some(
                (mutableProduct) =>
                  mutableProduct.id === product.id &&
                  mutableProduct.updatedAt === product.updatedAt,
              ),
            );

            mutableProducts.forEach((newProduct, newProductIndex) => {
              if (newProduct.unAvailable) return;

              const existingProduct = this.products.find(
                (storedProduct) =>
                  storedProduct &&
                  storedProduct.id === newProduct.id &&
                  storedProduct.updatedAt === newProduct.updatedAt,
              );

              if (
                !existingProduct ||
                (existingProduct &&
                  !(existingProduct.thumbnailImages?.length > 0))
              ) {
                // Load Product thumnails (not used in UI currently)
                // ------------------------------
                // newProduct.thumbnailImages = [];
                // const item =
                //   this.syncedProductMap.get(newProduct.id) ||
                //   this.syncedBundleMap.get(newProduct.id);
                // if (!item) return;
                // for (let i = 0; i < Math.min(item.thumbnails.length, 2); i++) {
                //   const thumbnailKey = item.thumbnails[i];
                //   Storage.get(thumbnailKey, { level: "public" }).then(
                //     (thumbnailImgSrc) => {
                //       const img = new Image();
                //       img.onload = () => {
                //         newProduct.thumbnailImages.push(thumbnailImgSrc);
                //         this.loadedProductThumbnails.push(newProduct.id);
                //       };
                //       img.onerror = (error) => {
                //         console.error("Error loading thumbnail image:", error);
                //       };
                //       img.src = thumbnailImgSrc;
                //     },
                //   );
                // }
              } else {
                mutableProducts.splice(newProductIndex, 1, {
                  ...existingProduct,
                  unAvailable: newProduct.unAvailable,
                });
              }
            });

            this.products = mutableProducts;
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        if (!this.initiallyLoaded) {
          this.initiallyLoaded = true;
        }

        this.queriedProducts = true;
      }
    },
  },

  // beforeDestroy() {
  //   store.commit("removeSubscriptions", [
  //     "Product-TeacherCart",
  //     "ProductBundle-TeacherCart",
  //   ]);

  //   store.commit("removeDatastorePredicates", ["Product", "ProductBundle"]);
  // },
};
</script>

<style lang="scss">
/* Hiding scrollbar for Chrome, Safari and Opera */
#selectedProductThumbnails::-webkit-scrollbar {
  display: none;
}

/* Hiding scrollbar for IE, Edge and Firefox */
#selectedProductThumbnails {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.productsSearchInputCSS .v-input__slot {
  margin-bottom: 0px !important;
}

.productsSearchInputCSS .v-select__selections {
  min-height: 36px !important;
}

// .primary-color-text-field-message .v-select__selections {
//   min-height: 36px !important;
// }

/* Table-specific styling */
.tiptap {
  table {
    border-collapse: collapse;
    table-layout: fixed;
    max-width: 100% !important;
    width: auto !important;
    min-width: 200px !important;
    margin: 0;
    overflow: hidden;

    td,
    th {
      min-width: 1em;
      border: 2px solid #ced4da;
      padding: 3px 5px;
      vertical-align: top;
      box-sizing: border-box;
      position: relative;

      > * {
        margin-bottom: 0;
      }
    }

    th {
      font-weight: bold;
      text-align: left;
      background-color: #f1f3f5;
    }

    .selectedCell:after {
      z-index: 2;
      position: absolute;
      content: "";
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(200, 200, 255, 0.4);
      pointer-events: none;
    }

    .column-resize-handle {
      position: absolute;
      right: -2px;
      top: 0;
      bottom: -2px;
      width: 4px;
      background-color: #adf;
      pointer-events: none;
    }
  }

  li {
    p {
      margin-bottom: 0;
    }
  }

  ul {
    margin-bottom: 16px;
  }

  ol {
    margin-bottom: 16px;
  }
}

.tableWrapper {
  overflow-x: auto;
}
</style>
